import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IoMdHome } from "react-icons/io";
import { FaHotel, FaUmbrellaBeach, FaHeart } from "react-icons/fa";
import { MdCall } from "react-icons/md";
import { CiStreamOn } from "react-icons/ci";
import "./NavbarMain.css";

const NavbarMain = () => {
  return (
    <>
      <input type="checkbox" id="menuToggle" hidden />
      <label htmlFor="menuToggle" className="navbar-toggle">☰</label>

      <div className="Navbar_Main">
        <Container>
          <div className="Navbar_Main-MenuBar">
            <div className="Navbar_Main-LeftGroup">
              <Link to="/" className="logo-section">
                <img className="logo-main" src="/Images/logo/logo.png" alt="Logo" />
              </Link>

              <div className="nav-links">
                <Link to="/" className="nav-item-link">
                  <img src="/Images/logo/home.png" className="nav-icon" />
                </Link>

                {/* International Dropdown */}
                <div className="nav-item-link dropdown">
                  <div className="dropdown-toggle">
                    <img src="/Images/logo/destination.png" className="nav-icon" />
                    International Destination
                  </div>
                  <div className="dropdown-menu">
                    <Link to="/europe" className="dropdown-item">Europe</Link>
                    <Link to="/bali" className="dropdown-item">Bali</Link>
                    <Link to="/mauritius" className="dropdown-item">Mauritius</Link>
                    <Link to="/malaysia" className="dropdown-item">Malaysia</Link>
                    <Link to="australia" className="dropdown-item">Australia</Link>
                    <Link to="/japan" className="dropdown-item">Japan</Link>
                    <Link to="/france" className="dropdown-item">France</Link>
                    <Link to="/uk" className="dropdown-item">UK</Link>
                    <Link to="/switzerland" className="dropdown-item">Switzerland</Link>
                    <Link to="/africa" className="dropdown-item">Africa</Link>
                    <Link to="/spain" className="dropdown-item">Spain</Link>
                    <Link to="/france" className="dropdown-item">France</Link>
                    <Link to="/italy" className="dropdown-item">Italy</Link>
                  </div>
                </div>

                {/*  Domestic Dropdown */}
                <div className="nav-item-link dropdown">
                  <div className="dropdown-toggle">
                    <img src="/Images/logo/dom-destination.png" className="nav-icon" />
                    Domestic Destination
                  </div>
                  <div className="dropdown-menu">
                    <Link to="/aandaman-and-nicobar" className="dropdown-item">Andaman and Nicobar</Link>
                    <Link to="/kerala" className="dropdown-item">Kerala</Link>
                    <Link to="/northeast" className="dropdown-item">North East</Link>
                    <Link to="/lakshadweep" className="dropdown-item">Lakshadweep</Link>
                    <Link to="/himachal-pradesh" className="dropdown-item">Himachal Pradesh</Link>
                    <Link to="/ladakh" className="dropdown-item">Ladakh</Link>
                    <Link to="/goa" className="dropdown-item">Goa</Link>
                    <Link to="/chikmagalur" className="dropdown-item">Chikmagalur</Link>
                    <Link to="/bangalore" className="dropdown-item">Bangalore</Link>
                    <Link to="/mysore" className="dropdown-item">Mysore</Link>
                    <Link to="/ooty" className="dropdown-item">Ooty</Link>
                    <Link to="/coorg" className="dropdown-item">Coorg</Link>
                    <Link to="/wayanad" className="dropdown-item">Wayanad</Link>
                    <Link to="/Nilambur" className="dropdown-item">Nilambur</Link>
                    <Link to="/gudalur" className="dropdown-item">Gudalur</Link>
                    <Link to="/munnar" className="dropdown-item">Munnar</Link>
                    <Link to="/alleppey" className="dropdown-item">Alleppey</Link>
                    <Link to="/thekkady" className="dropdown-item">Thekkady</Link>
                    <Link to="/kumarakom" className="dropdown-item">Kumarakom</Link>
                    <Link to="/thattekad" className="dropdown-item">Thattekad</Link>
                  </div>
                </div>

                <Link to="/" className="nav-item-link">
                  <img src="/Images/logo/wildlife.png"  className="nav-icon" />Wildlife
                </Link>
                  <Link to="/" className="nav-item-link">
                  <img src="/Images/logo/pilgrimage.png"  className="nav-icon" />Pilgrimage
                </Link>
                  <Link to="/hotels" className="nav-item-link">
                  <img src="/Images/logo/hotel.png"  className="nav-icon" />Hotels
                </Link>
                <Link to="/" className="nav-item-link">
                  <img src="/Images/logo/trekking.png"  className="nav-icon" />Treks
                </Link>
              </div>
            </div>
                <div>
              <a href="tel:+919980944799" className="contact-btn">
                <MdCall className="nav-icon" style={{ color: 'white' }} /> Contact Us
              </a>
              </div>    
          </div>
        </Container>
      </div>
    </>
  );
};

export default NavbarMain;
